module.exports = __webpack_public_path__ + "Server-Healthy.TentacleActive.9fd6674ac738a2e5f174a097db69790b.hashedasset.svg";